import React ,{useRef} from 'react'
import { Link } from 'react-router-dom'
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const Breadcrumb = ({ title, bg }) => {
      const container = useRef();


  useGSAP(
    () => {

 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      tl
        .fromTo(
          ".bredcrum_heading_animation",
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
            
          },
        )
        .fromTo(
          ".bredcrum_nav_animation",
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          },"0.3"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className="breadcumb-wrapper" style={{ backgroundImage: `url('${ bg}')`}}>
            {/* bg animated image/ */}
            <div className="container" ref={container}>
                <div className="row align-items-center">
                    <div className="col-lg-10">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title bredcrum_heading_animation">{title}</h1>
                            <ul className="breadcumb-menu bredcrum_nav_animation">
                                <li>
                                    <Link className='text-white ' to="/">Home</Link>
                                </li>
                                <li className="active text-white bredcrum_nav_animation">{title}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Breadcrumb